import { all, call, put, select, takeLatest } from "redux-saga/effects";
import { normalize, schema } from "normalizr";

import { showError } from "../../utils/sagasErrorHandler";

import { platformsRequest } from "./api";
import { platformsSelector } from "./selectors";
import { getPlatforms, setPlatforms } from "./actions";


const platformsSchema = new schema.Entity("platforms" , {},{ idAttribute: "code" });
const platformsListSchema = new schema.Array(platformsSchema);

export function* handlePlatformsWorker() {
    try {
        const { codes } = yield select(platformsSelector);

        if(!codes.length){
            yield put(setPlatforms({ isLoadingPlatforms: true }));

            const { platforms } = yield call(platformsRequest);

            const { result, entities } = normalize(platforms, platformsListSchema);

            yield put(setPlatforms({
                isLoadingPlatforms: false,
                platforms: entities.platforms,
                codes: result
            }));
        }
    } catch (error) {
        yield put(setPlatforms({ isLoadingPlatforms: false }));
        showError(error);
    }
}

export function* getPlatformsSaga() {
    yield all([
        yield takeLatest(getPlatforms, handlePlatformsWorker)
    ]);
}
